var VERSION_TYPE = 'Version must be an instance of @xams-entities/Version';
var EXACT_TYPE = 'Exact comparison check must be a boolean';
var VERSION_FORMAT_MINIMUM = 'Version must have at least one part';
var VERSION_FORMAT_MAXIMUM = 'Version must not have more than four parts';
var VERSION_FORMAT = 'Invalid version format';
export { VERSION_TYPE, VERSION_FORMAT_MINIMUM, VERSION_FORMAT_MAXIMUM, VERSION_FORMAT, EXACT_TYPE };